import React from 'react';
import { withStyles } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';

import styles from '../Privacy/styles';

const Terms = (props) => {
    const { classes } = props;

    return (
        <Container maxWidth={false} className={classes.blockContainer}>
            <div className={classes.mainBlock}>
                <Typography variant="h1" className={classes.mainTitleText}>
                    PINN Hub Terms and Conditions
                </Typography>
                <Typography variant="body1" className={classes.mainTitleDescription}>
                    Last updated: August 14, 2026
                </Typography>

                <Typography variant="h5" gutterBottom>
                    Use of the platform
                </Typography>
                <p>
                    PINN Hub provides research, project, solver-sharing, and PINNs Agent workflows. Use the platform
                    lawfully and only with material you are authorized to access, process, and share.
                </p>

                <Typography variant="h5" gutterBottom>
                    Agent uploads and improvement
                </Typography>
                <p>
                    Agent uploads are kept private to your account and are used within your authorized workspace.
                    Uploads may nevertheless be retained and used for training, quality, safety, and reliability
                    improvements. Do not upload passwords, API keys, confidential information, or regulated data.
                </p>

                <Typography variant="h5" gutterBottom>
                    Plans and generated content
                </Typography>
                <p>
                    Agent plans, validation results, and generated artifacts are provided for review. You are
                    responsible for checking generated content before using it in research or production systems.
                    Training and infrastructure mutation remain subject to deployment and account controls.
                </p>

                <Typography variant="h5" gutterBottom>
                    Availability and changes
                </Typography>
                <p>
                    The platform may change, be rate-limited, or become unavailable for maintenance and safety
                    reasons. We may update these terms as the platform evolves; the version shown at signup identifies
                    the consent requested for that signup flow.
                </p>

                <Typography variant="h5" gutterBottom>
                    Contact
                </Typography>
                <p>
                    Questions about these terms can be sent to nextgenaischool@gmail.com.
                </p>
            </div>
        </Container>
    );
};

export default withStyles(styles)(Terms);
